import React from "react";
import PropTypes from "prop-types";

/**
 * ArticleList - horizontálny carousel na zobrazovanie článkov
 * @param {Object[]} articles - Pole článkov [{ title, description, text, link, pub_date }]
 */
export default function ArticleList({ articles = [] }) {
  if (!articles.length) return null;
  const MAX_DESC_LENGTH = 100;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("sk-SK", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    } catch (e) {
      // Fallback pre neštandardné formáty, ktoré Date nemusí poznať
      return dateString.split(" ").slice(0, 4).join(" ");
    }
  };

  return (
    <div style={{ margin: "16px 0 8px 0" }}>
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: 16,
          padding: "4px 4px 12px 4px",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "thin",
          scrollbarColor: "#ccc #f1f1f1",
        }}
      >
        {articles.map((article, idx) => {
          const description = article.description || article.text || "";
          const shortDesc =
            description.length > MAX_DESC_LENGTH
              ? description.slice(0, MAX_DESC_LENGTH) + "…"
              : description;
          return (
            <div
              key={idx}
              style={{
                minWidth: 260,
                maxWidth: 260,
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.07)",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #e8e8e8",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "0 3px 10px rgba(0,0,0,0.07)";
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 15,
                  marginBottom: 8,
                  color: "#222",
                  minHeight: 42,
                }}
              >
                {article.title}
              </div>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 12 }}>
                {formatDate(article.pub_date)}
              </div>
              <div
                style={{
                  fontSize: 14,
                  color: "#555",
                  marginBottom: 16,
                  flexGrow: 1,
                  minHeight: 60,
                }}
              >
                {shortDesc}
              </div>
              <a
                href={article.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginTop: "auto",
                  background: "rgba(25, 118, 210, 0.08)",
                  color: "#1976d2",
                  borderRadius: 8,
                  padding: "10px 16px",
                  fontWeight: 600,
                  fontSize: 14,
                  textDecoration: "none",
                  transition: "background 0.2s",
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                Zobraziť celý článok
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.string,
      pub_date: PropTypes.string,
    })
  ),
};
